<template>
  <div class="product-row" v-show="isShow">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TabPaneHorizontal',
  props: {
    name: { type: String }
  },
  data () {
    return {
      isShow: false
    }
  }
}
</script>
